import { createAction, createSlice, PayloadAction } from '@reduxjs/toolkit';

import { startAppListening } from '../listenerMiddleware';

import { initialState } from './initialState';
import { getSidesheet } from './selectors';
import { SidesheetSlotItem } from './types';

export const sidesheetSlice = createSlice({
  name: 'sidesheet',
  initialState,
  reducers: {
    open: (state, action: PayloadAction<string>) => {
      state.current = action.payload;
      state.opened = state.slots[state.current].id;
    },
    close: state => {
      state.opened = null;
      state.current = null;
    },
    setSlots: (
      state,
      action: PayloadAction<{ sidesheetId: string; slot: SidesheetSlotItem }[]>,
    ) => {
      for (const { sidesheetId, slot } of action.payload) {
        state.slots[sidesheetId] = slot;
      }
    },
    setNoTransition: (state, action: PayloadAction<boolean>) => {
      state.noTransition = action.payload;
    },
  },
});

export const setSidesheetSlots = createAction<
  { sidesheetId: string; slot: SidesheetSlotItem }[],
  'sidesheet/setSlotsPipeline'
>('sidesheet/setSlotsPipeline');

export const resetSidesheetNoTransition = createAction(
  'sidesheet/resetNoTransition',
);

export const { actions: sidesheetActions, reducer: sidesheetReducer } =
  sidesheetSlice;

startAppListening({
  actionCreator: setSidesheetSlots,
  effect: async (action, listenerApi) => {
    await listenerApi.dispatch(sidesheetActions.setSlots(action.payload));

    const state = listenerApi.getState();

    const { current, opened, slots } = getSidesheet(state);
    if (!current) return;

    const shouldBeOpened = slots[current].id;
    if (!opened) return;

    if (shouldBeOpened !== opened) {
      await listenerApi.dispatch(sidesheetActions.setNoTransition(true));
      await listenerApi.dispatch(sidesheetActions.open(current));
      listenerApi.dispatch(resetSidesheetNoTransition());
    }
  },
});

startAppListening({
  actionCreator: resetSidesheetNoTransition,
  effect: async (action, listenerApi) => {
    listenerApi.dispatch(sidesheetActions.setNoTransition(false));
  },
});
